var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":"pop"}},[(_vm.props.count)?_c('span',{key:_vm.props.count,class:_vm.data.staticClass},[_vm._v("\n    "+_vm._s(_vm.props.count)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }